import { paperStyles } from '@festina-life/ui/libs'
import cx from 'classnames'

import type { SearchCategoryKey } from './types'
import { useCategoryTranslations } from './useCategoryTranslations'

type Props = {
  categories: SearchCategoryKey[]
}

export const MatchCategories = ({ categories }: Props) => {
  const categoryTranslations = useCategoryTranslations()

  if (!categories.length) {
    return null
  }

  return (
    <div className="absolute bottom-1 right-1 flex gap-x-2 opacity-85">
      {categories.map((category) => (
        <div
          className={cx(
            'rounded-md p-1 text-sm',
            paperStyles({ isFaded: true, borders: ['all'] }),
          )}
          key={category}
        >
          {categoryTranslations[category]}
        </div>
      ))}
    </div>
  )
}
